import React from 'react';
import { DownloadIcon, ShoppingCartIcon, ClockIcon } from 'lucide-react';
export function ProcessSection() {
  const steps = [{
    icon: <DownloadIcon className="w-10 h-10 text-brand-teal" data-id="element-91" />,
    number: '1',
    title: 'Descargas el plan',
    description: 'Inmediatamente en tu teléfono o computadora.'
  }, {
    icon: <ShoppingCartIcon className="w-10 h-10 text-brand-teal" data-id="element-92" />,
    number: '2',
    title: 'Haces la compra',
    description: 'Realizas la compra mensual usando nuestra lista maestra de supermercado.'
  }, {
    icon: <ClockIcon className="w-10 h-10 text-brand-teal" data-id="element-93" />,
    number: '3',
    title: 'Ensamblas',
    description: 'Eliges un menú de la semana y tardas exactamente 10 minutos cada mañana.'
  }];
  return <section className="py-24 bg-[#EAF7F7]" data-id="element-94">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-95">
        <div className="text-center mb-16" data-id="element-96">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-brown mb-4" data-id="element-97">
            Así de fácil funciona
          </h2>
          <p className="text-lg text-brand-brown/70 max-w-2xl mx-auto" data-id="element-98">
            Un proceso diseñado para eliminar la fricción y devolverte el
            tiempo.
          </p>
        </div>

        <div className="relative" data-id="element-99">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-brand-teal/20 -translate-y-1/2 z-0" data-id="element-100"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative z-10" data-id="element-101">
            {steps.map((step, idx) => <div key={idx} className="flex flex-col items-center text-center" data-id="element-102">
                <div className="w-24 h-24 bg-white rounded-full shadow-lg flex items-center justify-center mb-6 relative border-4 border-[#EAF7F7]" data-id="element-103">
                  <div className="absolute -top-3 -right-3 w-8 h-8 bg-brand-yellow rounded-full flex items-center justify-center text-brand-brown font-bold text-sm shadow-sm" data-id="element-104">
                    {step.number}
                  </div>
                  {step.icon}
                </div>
                <h3 className="text-2xl font-bold text-brand-brown mb-3" data-id="element-105">
                  {step.title}
                </h3>
                <p className="text-brand-brown/80 text-lg" data-id="element-106">
                  {step.description}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}